var E = 30;
export { E as DEFAULT_PER_PAGE };